<template>
    <div>
        <v-menu v-model="menuCollect" :close-on-content-click="false" offset-x right top nudge-right="10">
            <template v-if="this.item.status == 'hold'" v-slot:activator="{ on, attrs }">
                <v-btn icon small aria-label="Collecter" v-bind="attrs" v-on="on"><v-icon>mdi-check</v-icon></v-btn>
            </template>

            <v-card style="min-width: 350px; padding: 20px">
                <span>{{ $t('checkout.fingerprint.collect_title') }}</span>

                <v-divider></v-divider>

                <span v-if="error" style="color: red">{{ error }}</span>

                <v-list>
                    <div style="width: 100%">
                        <v-form v-model="valid">
                            <v-text-field
                                single-line
                                dense
                                :label="$t('checkout.fingerprint.amount')"
                                v-model="amount"
                                :rules="[
                                    rules.required,
                                    rules.number,
                                    (value) => parseFloat(value) <= this.item.amount || $t('checkout.fingerprint.invalid_value'),
                                ]"
                                type="number"
                                suffix="$symbolCurrency"
                                style="max-width: 200px"
                                :max="item.amount"
                            ></v-text-field>
                        </v-form>
                    </div>
                </v-list>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn text @click="menuCollect = false"> {{ $t('checkout.fingerprint.cancel') }} </v-btn>
                    <v-btn color="primary" text @click="collect" :disabled="!valid" :loading="loading">
                        {{ $t('checkout.fingerprint.collect') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-menu>
        <v-menu v-model="menuSupress" :close-on-content-click="false" offset-x right top nudge-right="10">
            <template v-slot:activator="{ on, attrs }">
                <v-btn icon small aria-label="Supprimer" v-bind="attrs" v-on="on"><v-icon>mdi-close</v-icon></v-btn>
            </template>

            <v-card style="min-width: 350px; padding: 20px">
                <span>{{ $t('checkout.fingerprint.delete_title') }}</span>

                <v-divider></v-divider>

                <span v-if="error" style="color: red">{{ error }}</span>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn text @click="menuSupress = false"> {{ $t('checkout.fingerprint.cancel') }} </v-btn>
                    <v-btn color="primary" text @click="supress" :disabled="!valid" :loading="loading">
                        {{ $t('checkout.fingerprint.delete') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-menu>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    props: ['userId', 'orderId', 'item'],
    mounted() {
        this.amount = this.item.amount
    },
    data: () => {
        return {
            amount: 0,
            menuCollect: false,
            menuSupress: false,
            valid: false,
            loading: false,
            error: null,
            rules: {
                required: (value) => !!value || this.$t('checkout.fingerprint.required'),
                number: (value) => {
                    const pattern = /^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/
                    return pattern.test(value) || this.$t('checkout.fingerprint.wrong_format')
                },
            },
        }
    },
    methods: {
        async collect() {
            this.loading = true
            this.error = null
            axios
                .post(`/back-office/caisse/collectEmpreinte`, { fingerprinId: this.item.id, montant: this.amount })
                .then(() => {
                    window.location.reload()
                })
                .catch((error) => {
                    this.error = error?.response?.data?.message || this.$t('checkout.fingerprint.error')
                })
                .finally(() => {
                    this.loading = false
                })
        },
        async supress() {
            this.loading = true
            this.error = null
            axios
                .post(`/back-office/caisse/suppresseEmpreinte`, { id: this.item.id })
                .then(() => {
                    window.location.reload()
                })
                .catch((error) => {
                    this.error = error?.response?.data?.message || this.$t('checkout.fingerprint.error')
                })
                .finally(() => {
                    this.loading = false
                })
        },
    },
}
</script>
